<template>
    <div class="login">
        <div class="content">
            <div class="info" style="cursor: default">
                <div class="weeduc-lang-switcher-wrap">
                    <LanguageSwitcher class="weeduc-lang-switcher--light" />
                </div>
                <div class="logo">
                    <img
                        alt="Weeduc"
                        src="@/assets/Weflix/Weflix-Logo-Total-Branco.png"
                        style="width: 200px"
                        v-show="isWeflix"
                    />
                    <img
                        alt="Weeduc"
                        src="@/assets/logo_white.png"
                        style="width: 200px"
                        v-show="isWeeduc"
                    />
                </div>
                <div class="company" v-show="numberSites > 1">
                    <h5 class="company-title">{{ $t('auth.helloUser', { name: userName }) }}</h5>
                    <p class="company-subtitle">{{ $t('auth.whatToAccess') }}</p>
                    <vue-select
                        v-model="selectedCompany"
                        :options="filteredCompanies"
                        :filterable="false"
                        @search="(val) => (filterText = val)"
                        :placeholder="$t('auth.selectCompany')"
                        class="company-select"
                    >
                        <template #selected-option="{ label }">
                            {{
                                label.length > 20
                                    ? label.substring(0, 20) + '...'
                                    : label
                            }}
                        </template>
                        <template #no-options>
                            {{ $t('auth.noCompanyFound') }}
                        </template>
                    </vue-select>
                    <div class="action">
                        <button
                            class="btn-success"
                            :class="{
                                weflix:
                                    typeSystemLocal == 1 ||
                                    typeSystemLocal == 2,
                            }"
                            @click="
                                getTokenManyCompany(
                                    filteredCompanies.indexOf(selectedCompany)
                                )
                            "
                        >
                            {{ $t('auth.access') }}
                        </button>
                    </div>
                </div>

                <div class="form" v-show="numberSites == 1">
                    <form @submit.prevent="handleSubmit" class="form">
                        <h4 class="form-title">{{ $t('auth.forgotTitle') }}</h4>
                        <p class="form-subtitle">{{ $t('auth.forgotSubtitle') }}</p>

                        <div class="mb-3">
                            <label for="exampleInputEmail1" class="form-label">{{ $t('auth.email') }}</label>
                            <input
                                type="email"
                                v-model="email"
                                class="form-control"
                                :class="{ 'is-invalid': emailError }"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                                required
                                :disabled="isLoading"
                                :placeholder="$t('auth.emailPlaceholder')"
                                @input="validateEmail"
                            />
                            <div class="invalid-feedback" v-if="emailError">
                                {{ emailError }}
                            </div>
                            <small class="form-text">
                                {{ $t('auth.forgotHint') }}
                            </small>
                        </div>

                        <div class="erro" v-show="erroReset">
                            <small>{{ mensageErro }}</small>
                        </div>

                        <div class="success" v-show="successReset">
                            <small>{{ mensageSuccess }}</small>
                        </div>

                        <div class="mb-4 text-center" style="margin-top: 32px;">
                            <button
                                type="submit"
                                class="btn-success"
                                :class="{
                                    weflix: typeSystemLocal == 1 || typeSystemLocal == 2,
                                }"
                                :disabled="isLoading || !isFormValid"
                            >
                                <span v-if="isLoading">{{ $t('auth.sending') }}</span>
                                <span v-else>{{ $t('auth.requestNewPassword') }}</span>
                            </button>
                        </div>

                        <div class="text-center">
                            <a
                                href="/login"
                                :class="{ weflix: typeSystemLocal == 2 }"
                                class="back-to-login"
                                @click.prevent="backLogin"
                            >
                                {{ $t('auth.backToLogin') }}
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import apiPassword from '@/utils/password.js';
import loginApi from '@/utils/login.js';
import userApi from '@/utils/user.js';
import ApiWeflix from '@/utils/Weflix/Website/index.js';
import vueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import LanguageSwitcher from '@/components/i18n/LanguageSwitcher.vue';

export default {
    name: 'ForgotPassword',
    components: {
        vueSelect,
        LanguageSwitcher,
    },
    data() {
        return {
            email: '',
            emailError: '',
            token: null,
            typeIdLocal: null,
            users: null,
            credentials: null,
            websites: null,
            refreshToken: null,
            idUser: null,
            lististes: null,
            numberSites: 1,
            logo: null,
            selectedCompany: null,
            darkMode: null,
            userName: null,
            mensageErro: '',
            mensageSuccess: '',
            erroReset: false,
            successReset: false,
            isLoading: false,
            weflixPageLogin: false,
            typeSystemLocal: 1,
            baseUrl:
                process.env.NODE_ENV === 'development'
                    ? process.env.VUE_APP_BASE_URL_HOMOLOGATION
                    : window.location.origin,

            filterText: '',
            filteredCompanies: [],
        };
    },
    computed: {
        ...mapState(['typeId', 'numberIntensTable', 'typeSystem', 'dark']),
        isFormValid() {
            return this.email && 
                   this.email.includes('@') && 
                   !this.emailError;
        },
        isWeflix() {
            return Number(this.typeSystemLocal) === 2;
        },
        isWeeduc() {
            return Number(this.typeSystemLocal) !== 2;
        },
    },
    methods: {
        ...mapActions([
            'storeTypeId',
            'login',
            'storeToken',
            'storeWebsites',
            'storeRefreshToken',
            'storeUser',
            'toggleDarkMode',
            'storeNumberIntensTable',
            'storeTypeSystem',
            'storeCompanys',
            'restoreDarkMode',
        ]),
        validateEmail() {
            this.emailError = '';
            
            if (this.email.length > 0 && !this.email.includes('@')) {
                this.emailError = this.$t('auth.invalidEmail');
            }
        },
        async handleSubmit() {
            if (!this.isFormValid) {
                return;
            }

            this.isLoading = true;
            this.erroReset = false;
            this.successReset = false;

            const obj = {
                'email': this.email,
                'typeSystem': this.typeSystemLocal,
                // "url": this.baseUrl,
                // "url": "https://app.weeduc.com.br",
            }

            try {
                const response = await apiPassword.resetPassowrdEmail(obj);
                console.debug('Resposta da API:', response);
                
                // Se chegou até aqui sem erro, considera como sucesso (status 200)
                this.successReset = true;
                this.erroReset = false;
                this.mensageSuccess = response?.message || this.$t('auth.emailSentInbox');

            } catch (error) {
                console.error('Erro na requisição:', error);
                this.erroReset = true;
                this.successReset = false;
                
                // Tratamento específico para diferentes tipos de erro
                if (error.response) {
                    const status = error.response.status;
                    const errorData = error.response.data;
                    
                    switch (status) {
                        case 404:
                            this.mensageErro = this.$t('auth.emailNotFound');
                            break;
                        case 400:
                            this.mensageErro = errorData?.message || this.$t('auth.invalidData');
                            break;
                        case 422:
                            this.mensageErro = errorData?.message || this.$t('auth.invalidEmailFormat');
                            break;
                        case 500:
                            this.mensageErro = this.$t('auth.serverError');
                            break;
                        case 503:
                            this.mensageErro = this.$t('auth.serviceUnavailable');
                            break;
                        default:
                            this.mensageErro = errorData?.message || this.$t('auth.sendEmailError');
                    }
                } else if (error.request) {
                    this.mensageErro = this.$t('auth.connectionError');
                } else {
                    this.mensageErro = this.$t('auth.unexpectedError');
                }
            } finally {
                this.isLoading = false;
            }
        },
        backLogin() {
            this.$router.push('/login');
        },
        setNumberItensPageOnLoad() {
            if (window.innerHeight > 680) {
                this.storeNumberIntensTable({ numberIntensTable: 8 });
            } else if (
                window.innerHeight < 650 &&
                window.innerHeight > 450
            ) {
                this.storeNumberIntensTable({ numberIntensTable: 5 });
            } else {
                this.storeNumberIntensTable({ numberIntensTable: 4 });
            }
        },

        async getLogo() {
            let aux;
            
            // Verifica se é localhost e usa a URL do .env
            if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                aux = process.env.VUE_APP_BASE_URL_HOMOLOGATION;
            } else {
                aux = this.baseUrl.replace(/\/$/, '');
            }
            console.debug(aux);

            const url = aux.split('/login')[0];
            const obj = { url: url };
            try {
                const response = await loginApi.logo(obj);
                this.logo = 'https://image.weeduc.com/' + response.logo;
                this.typeSystemLocal = response.typeSystem;
                this.storeTypeSystem({ typeSystem: response.typeSystem });
            } catch (error) {
                console.error('Error fetching API:', error);
            }
        },
    },
    mounted() {
        this.setNumberItensPageOnLoad();
        this.getLogo();
    },
};
</script>

<style scoped>
.item {
    border: none;
}
.action {
    display: flex;
    justify-content: end;
    padding: 15px 0 5px;
}
.form {
    max-width: 100%;
    margin: 0;
    text-align: left;
    min-height: auto;
    position: relative;
}
.login {
    height: 100vh;
    display: flex;
    background-image: url('@/assets/Weflix/bg-login-weflix.png');
    background-size: cover;
}
.login.weflix {
    height: 100vh;
    display: flex;
    background-image: url('@/assets/Weflix/bg-login-weflix.png');
    background-size: cover;
}
.mb-5.text-center.btn {
    width: 100%;
    position: absolute;
    bottom: 0;
}
.logo {
    display: flex;
    justify-content: center;
    margin: 20px;
    margin-top: -100px;
    margin-bottom: 40px;
    transform: translateY(-10px);
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}
.weeduc-lang-switcher-wrap {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
}
.content {
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 10px;
}
.info {
    width: 450px;
    min-height: 500px;
    padding: 40px 30px;
    background-color: white;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}
button.btn.btn-success {
    width: 100%;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, #19c7d0 0%, #17a2b8 100%);
    color: white;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 15px rgba(25, 199, 208, 0.3);
}
button.btn.btn-success:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(25, 199, 208, 0.4);
    background: linear-gradient(135deg, #17a2b8 0%, #19c7d0 100%);
}
button.btn.btn-success:active {
    transform: translateY(0);
}
button.btn.btn-success:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 8px rgba(25, 199, 208, 0.2);
}
.mb-3 {
    margin: 20px 0px;
}
.mb-3.forgot_password {
    color: red;
    margin: 0 !important;
    font-size: 11px;
    text-decoration: none;
    display: flex;
    justify-content: end;
}
.mb-3.forgot_password a {
    color: #19c7d0;
}
.mb-3.password {
    position: relative;
}
.mb-3.password i {
    position: absolute;
    top: 45px;
    right: 15px;
    color: #b4b4b4;
    cursor: pointer;
    transition: color 0.3s ease;
}
.mb-3.password i:hover {
    color: #19c7d0;
}
.form-control {
    border: 2px solid #e9ecef;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 16px;
    transition: all 0.3s ease;
    background-color: #f8f9fa;
}
.form-control:focus {
    border-color: #19c7d0;
    box-shadow: 0 0 0 0.2rem rgba(25, 199, 208, 0.25);
    background-color: white;
}
.form-control.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #dc3545;
    font-weight: 500;
}
.form-control::placeholder {
    color: #adb5bd;
    font-size: 14px;
}
.company {
    max-width: 100%;
    margin: 0px;
    text-align: left;
    position: relative;
    padding: 20px;
    border-radius: 8px;
}
.company-title {
    font-size: 1.5rem;
    margin-bottom: 10px;
    color: #333;
    font-weight: 600;
}
.company-subtitle {
    font-size: 1rem;
    color: #666;
    margin-bottom: 20px;
}
.company-select {
    margin-bottom: 15px;
}
.company button.btn-success {
    margin-top: 15px;
    padding: 12px;
    font-size: 1rem;
    font-weight: 500;
    border: none;
    transition: all 0.3s ease;
}
.company button.btn-success:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.option-company {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    padding: 12px 0;
}
.erro {
    margin: 16px 0;
    padding: 12px 16px;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 8px;
    animation: slideIn 0.3s ease;
}
.erro small {
    color: #721c24;
    font-weight: 500;
    font-size: 14px;
}
.success {
    margin: 16px 0;
    padding: 12px 16px;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 8px;
    animation: slideIn 0.3s ease;
}
.success small {
    color: #155724;
    font-weight: 500;
    font-size: 14px;
}
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.form-title {
    text-align: center;
    margin-bottom: 8px;
    color: #2c3e50;
    font-weight: 700;
    font-size: 28px;
    letter-spacing: -0.5px;
}
.form-subtitle {
    text-align: center;
    margin-bottom: 32px;
    color: #6c757d;
    font-size: 16px;
    line-height: 1.5;
}
.form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.form-text {
    margin-top: 8px;
    display: block;
    color: #6c757d;
    font-size: 12px;
    line-height: 1.4;
}
.back-to-login {
    color: #19c7d0;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}
.back-to-login:hover {
    color: #17a2b8;
    text-decoration: none;
    transform: translateX(-2px);
}
.back-to-login.weflix {
    color: #0d1a7e;
}
.back-to-login.weflix:hover {
    color: #1a237e;
}
button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.option-company:last-child {
    border: none;
}

@media (max-width: 600px) {
    .info {
        width: 87%;
        min-height: 450px;
        padding: 30px 20px;
    }

    .logo {
        margin-top: -90px;
        margin-bottom: 30px;
    }
    .form {
        margin: 0px 10px;
        padding-bottom: 10px;
    }
    .option-company:last-child {
        border: none;
    }
    .company {
        max-width: 100%;
        margin: 0 16px;
        padding: 15px;
    }
    .company-title {
        font-size: 1.3rem;
    }
    .company-subtitle {
        font-size: 0.9rem;
    }
    .mb-3 {
        margin: 12px 0px;
    }
}
svg.svg-inline--fa.fa-eye,
svg.svg-inline--fa.fa-eye-slash {
    position: absolute;
    top: 45px;
    right: 5px;
    font-size: 15px !important;
    color: #dee2e6 !important;
}
button.btn-success.weflix {
    background: linear-gradient(135deg, #0d1a7e 0%, #1a237e 100%) !important;
    width: 100%;
    color: white;
    padding: 14px 24px;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(13, 26, 126, 0.3);
}
button.btn-success.weflix:hover {
    background: linear-gradient(135deg, #1a237e 0%, #0d1a7e 100%) !important;
    box-shadow: 0 6px 20px rgba(13, 26, 126, 0.4);
}
a.weflix {
    color: #0d1a7e !important;
}
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown-content a:hover {
    background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown:hover .dropbtn {
    background-color: #3e8e41;
}
@media (max-width: 600px) {
    .info {
        width: 87%;
        padding: 10px;
    }
}
</style>
<style>
.vs__actions > button.vs__clear svg,
.vs__actions > svg.vs__open-indicator {
    width: 17px;
    /* color: red; */
}
input.vs__search {
    position: absolute;
    width: 100%;
    height: 20px;
}
div#vs7__combobox {
    min-height: 30px;
}
.vs__selected-options {
    height: 24px;
}
</style>
